import React, { useEffect, useState } from 'react';
import { useParams } from 'umi';
import Loading from '@/pages/dashboard/components/Loadings';
import { stringToJson } from '@/pages/dashboard/utils/stringToJson';
import { CommonPageRenderType, IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import classNames from 'classnames';
import Render from '@/pages/dashboard/components/PageContainer/Render';
import { getPageConfig } from '@home/services/studio';
import './index.scss';

type FrameType = 'studio' | 'game';
interface Iprops extends CommonPageRenderType {
  className?: string;
  style?: React.CSSProperties;
  frameType: FrameType;
  [key: string]: any;
}

const CommonPageRender = (props: Iprops) => {
  const { reqParams, pageConfigInit, frameType, studioData,  className, style, ...restProps } = props;
  const { studioId, gameCode } = useParams() || {} as any;

  const codeMap: Record<FrameType, string> = {
    studio: studioId,
    game: gameCode,
  };
  const [pageConfig, setPageConfig] = useState<IPageConfigType>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPageConfig({
      frame_type: frameType,
      code: codeMap[frameType],
      path: reqParams,
    }).then(res => {
      const resDataConfig = res?.view_config;
      const config = resDataConfig ? stringToJson(resDataConfig) : pageConfigInit;
      // const toBackendConfig = jsonToString(pageConfigInit)
      // console.log('入库配置',toBackendConfig)
      setPageConfig(config);
      setLoading(false);
    }).catch((err) => {
      console.log('后端配置错误或者配置为空', err);
      setPageConfig(pageConfigInit);
      setLoading(false);
    });
  }, [frameType]); // 依赖项更新


  return (
    <>
      {loading ?
        <Loading /> : (pageConfig && <div className={classNames('dbh-custom-page-box', className)} style={style}>
          <Render data={{ frameType, frameCode: codeMap[frameType], studioData, ...restProps }} config={pageConfig} />
        </div>)
      }
    </>
  );
};

export default CommonPageRender;
